var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import classnames from 'classnames';
import Notification from './Notification';

var Notifications = (_temp2 = _class = function (_Component) {
  _inherits(Notifications, _Component);

  function Notifications() {
    var _temp, _this, _ret;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleRequestHide = function (notification) {
      return function () {
        var onRequestHide = _this.props.onRequestHide;

        if (onRequestHide) {
          onRequestHide(notification);
        }
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Notifications.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        notifications = _props.notifications,
        enterTimeout = _props.enterTimeout,
        leaveTimeout = _props.leaveTimeout;

    var className = classnames('notification-container', {
      'notification-container-empty': notifications.length === 0
    });
    return React.createElement(
      'div',
      { className: className },
      React.createElement(
        ReactCSSTransitionGroup,
        {
          transitionName: 'notification',
          transitionEnterTimeout: enterTimeout,
          transitionLeaveTimeout: leaveTimeout
        },
        notifications.map(function (notification) {
          return React.createElement(Notification, {
            key: notification.id,
            type: notification.type,
            position: notification.position,
            title: notification.title,
            message: notification.message,
            showCloseButton: notification.showCloseButton,
            timeOut: notification.timeOut,
            onClick: notification.onClick,
            bgColor: notification.bgColor,
            iconClassName: notification.iconClassName,
            onRequestHide: _this2.handleRequestHide(notification)
          });
        })
      )
    );
  };

  return Notifications;
}(Component), _class.defaultProps = {
  notifications: [],
  onRequestHide: function onRequestHide() {},
  enterTimeout: 400,
  leaveTimeout: 400
}, _temp2);
Notifications.propTypes = process.env.NODE_ENV !== "production" ? {
  notifications: PropTypes.array.isRequired,
  onRequestHide: PropTypes.func,
  enterTimeout: PropTypes.number,
  leaveTimeout: PropTypes.number
} : {};


export default Notifications;